export const css = {
    root: '_3NAh2OOA',
    details: '_1qNdKieT',
    more: '_8vkbM5g7',
    pageNav: 'hDuATsyI',
    pageNumber: '_1u8SJ6SX',
    active: '_1GLysweu',
    ' _key': 'apic-theme/dojo/grid-paginated-footer'
};
export default css;
